import * as React from 'react';
import getHighlightedTextForSuggestion from '../../utils/getHighlightedTextForSuggestion';
import SearchSuggestion from './SearchSuggestion';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { LARGE_SUGGESTION_HEIGHT, SMALL_SUGGESTION_HEIGHT } from '../../constants';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import { EventSuggestion } from 'owa-search-service';
import { observer } from 'mobx-react-lite';
import { SearchScenarioId } from 'owa-search-next-common';
import highlightDisplayText from '../../utils/highlightDisplayText';

const searchSuggestionStyles = require('./SearchSuggestion.scss');
const styles = require('./EventSearchSuggestion.scss');

export interface EventSearchSuggestionProps {
    index: number;
    scenarioId: SearchScenarioId;
    suggestion: EventSuggestion;
    suggestionSetTraceId: string;
}

const EventSearchSuggestion = observer(function EventSearchSuggestion(
    props: EventSearchSuggestionProps
) {
    const { index, scenarioId, suggestion, suggestionSetTraceId } = props;

    const highlightText = highlightDisplayText(suggestion.Text);

    const contentContainerStyle: React.CSSProperties = {
        lineHeight: `${LARGE_SUGGESTION_HEIGHT}px`,
    };

    const eventContentContainerStyle: React.CSSProperties = {
        lineHeight: `${SMALL_SUGGESTION_HEIGHT / 2}px`,
    };

    const secondaryData: string[] = [];

    if (suggestion.Start) {
        secondaryData.push(formatMeetingTimeSpan(suggestion.Start, suggestion.End));
    }

    if (suggestion.Location && suggestion.Location !== '') {
        secondaryData.push(suggestion.Location);
    }

    const secondaryDataString = secondaryData.join(', ');

    return (
        <SearchSuggestion
            ariaLabel={suggestion.Subject}
            content={
                <div className={styles.container} style={contentContainerStyle}>
                    <Icon
                        className={searchSuggestionStyles.icon}
                        iconName={ControlIcons.Calendar}
                    />
                    <div
                        className={styles.eventContentContainer}
                        style={eventContentContainerStyle}>
                        <div className={styles.eventSubject}>
                            {getHighlightedTextForSuggestion(highlightText)}
                        </div>
                        {secondaryDataString && (
                            <div className={styles.secondaryText}>
                                <span>{secondaryDataString}</span>
                            </div>
                        )}
                    </div>
                </div>
            }
            suggestion={suggestion}
            scenarioId={scenarioId}
            suggestionSetTraceId={suggestionSetTraceId}
            index={index}
        />
    );
});

export default EventSearchSuggestion;
